import React from 'react';
import { PersonInformation, PersonInformationModifier } from '../../../../components/molecules/PersonInformation';
import { dateFromNow } from '../../DateFormat';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { PostReply } from '../Post.types';
import { isDeletedUser } from '../../../../types/api/UserProfile';

type PostBasePerson = {
  model: PostReply;
};

export function PostPerson({ model }: PostBasePerson) {
  const { t } = useSonTranslation('Posts');
  return (
    <div className="posts__person">
      <PersonInformation
        {...model.author}
        infoCardUrl={isDeletedUser(model.author) ? undefined : model.author.personInfoCardUrl}
        modifier={PersonInformationModifier.POST}
      />

      <dl className="posts__time-container">
        <dt className="invisible">{t('default.created')}:</dt>
        <dd>
          <time dateTime={model.createDate} className="posts__time">
            {dateFromNow(model.createDate)}
          </time>
          {model.editDate && (
            <time dateTime={model.editDate} className="posts__time">
              {t(`default.replied`) + dateFromNow(model.editDate)}
            </time>
          )}
        </dd>
      </dl>
    </div>
  );
}
